import { useEffect, useState } from 'react'
import { documentBlob } from '@/core/api/documents'

export type DokumentBlob = { blob: Blob | null; laedt: boolean }

export function useDokumentBlob(dokumentId: string | null): DokumentBlob {
  const [geladen, setGeladen] = useState<ReadonlyMap<string, Blob | null>>(new Map())

  useEffect(() => {
    if (!dokumentId || geladen.has(dokumentId)) return
    let cancelled = false
    documentBlob(dokumentId)
      .catch((e: unknown) => {
        console.error("Dokument laden fehlgeschlagen:", e)
        return null
      })
      .then((blob) => {
        if (!cancelled) setGeladen((prev) => new Map(prev).set(dokumentId, blob))
      })
    return () => {
      cancelled = true
    }
  }, [dokumentId, geladen])

  return {
    blob: dokumentId ? (geladen.get(dokumentId) ?? null) : null,
    laedt: !!dokumentId && !geladen.has(dokumentId),
  }
}
